import { self } from 'store'
import './style/navbar.scss'
import { A } from '@solidjs/router'

export const Navbar = () => {
    return <div class='navbar-fnd'>
        <div class='left'>
            <A href='/'>Home</A>
            <A href='/wheats/'>Wheats</A>
            <A href='/wheat-kernel/'>Wheat Kernels</A>
            <A href='/farmers/'>Farmers</A>
            <A href='/plugin/'>Plugin</A>
            <A href='/kernel-state/'>Kernel State</A>
            <A href='/tasks/'>Tasks</A>
        </div>
        <div id='nav_portal'></div>
        <div class='right'>{self.user.name || '@' + self.user.username}</div>
    </div>
}
